module.exports = __webpack_public_path__ + "static/media/poemwomen.fc560d39.jpeg";